var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"BzOb_Account",attrs:{"tag":"div","to":"/login"}},[_c('transition',{attrs:{"name":"zoomr_f","mode":"out-in"}},[(_vm.logged == false)?_c('img',{attrs:{"src":require("../../assets/account_base.svg")}}):_vm._e(),(_vm.logged == true)?_c('avatar',{attrs:{"username":"Alena Vlasatá","size":48}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }